import React from 'react'
import styled from 'styled-components'
import { Copy } from '../../../Common'

export const Notice = ({ notice }: { notice: string }) => {
  return (
    <CopyContainer>
      <Copy html={notice} />
    </CopyContainer>
  )
}

const CopyContainer = styled.div.attrs({
  className: 'px-3 mb-3',
})`
  & > div p {
    font-size: 1.2rem;
    font-style: italic;
  }
`
